import type { ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import type { KittTransitionProps } from '../propTypes';
import styles from './styles.module.css';

const classNames = {
  appear: styles.Enter,
  appearActive: styles.EnterActive,
  enter: styles.Enter,
  enterActive: styles.EnterActive,
  exit: styles.Exit,
  exitActive: styles.ExitActive,
};

export function Rotate({
  children,
  appear,
  visible,
  onExit,
  onEnter,
  onEntered,
  onExited,
}: KittTransitionProps): ReactNode {
  return (
    <CSSTransition
      unmountOnExit
      appear={appear}
      classNames={classNames}
      in={visible}
      timeout={400}
      onEnter={onEnter}
      onEntered={onEntered}
      onExit={onExit}
      onExited={onExited}
    >
      {children()}
    </CSSTransition>
  );
}
